import type { SymbolKey } from '@/entities/symbol';
import { isBeforeWithOrder, PERIOD_TYPE_SORTING_ORDER } from '@/pages/Catalog/utils/sorts';

export const takeItemBasedOnOrder = (existing: SymbolKey, item: SymbolKey) => {
  if (Number(existing.TimeRef) < Number(item.TimeRef)) {
    return item;
  }
  if (Number(existing.TimeRef) === Number(item.TimeRef)) {
    const isPeriodTypeBefore = isBeforeWithOrder(
      existing.PeriodType,
      item.PeriodType,
      PERIOD_TYPE_SORTING_ORDER
    );
    if (isPeriodTypeBefore > 0) {
      return item;
    } else if (isPeriodTypeBefore === 0) {
      if (existing.Period > item.Period) {
        return item;
      }
    }
  }
  return existing;
};
